<template>
  <div
    class="copy-btn"
    :class="{ 'is-active': isActive }"
    :aria-label="$t(!isActive ? 'Copy' : 'Copied')"
    @click="copyText"
  >
    <img src="@/assets/svg/copy.svg" alt="" />
  </div>
</template>
  <script>
export default {
  props: {
    targetTxt: {
      type: String,
      default: '',
    },
  },
  data: () => {
    return {
      isActive: false,
    };
  },

  methods: {
    copyText() {
      this.isActive = true;
      setTimeout(() => {
        this.isActive = false;
      }, 3000);
      this.$clipboard(this.targetTxt);
    },
  },
};
</script>
  <style lang="scss" scoped>
.copy-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: transparent;
  cursor: pointer;

  img {
    width: 14px;
    height: 14px;
    display: block;
    transition: opacity 0.15s ease;
  }

  &.is-active img {
    opacity: 0.5;
  }
}
</style>
  